class ProductDetailsPanels extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();

    this.measure = this.measure.bind(this);

    this.measure();

    window.addEventListener("resize", this.measure);

    document.fonts?.ready.then(this.measure);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.measure);
  }

  measure() {
    if (this.elements.panels.length === 0) {
      return;
    }

    this.style.removeProperty("--panel-height");

    let tallest = 0;

    this.elements.panels.forEach((panel) => {
      const was_hidden = panel.hasAttribute("hidden");

      if (was_hidden) {
        panel.removeAttribute("hidden");
      }

      tallest = Math.max(tallest, panel.getBoundingClientRect().height);

      if (was_hidden) {
        panel.setAttribute("hidden", "");
      }
    });

    this.style.setProperty("--panel-height", `${Math.ceil(tallest)}px`);
  }
}

customElements.define("product-details-panels", ProductDetailsPanels);

class ProductIngredientTabs extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();

    if (this.elements.flavors.length === 0) {
      return;
    }

    this.elements.flavors.forEach((flavor) => {
      this.addDirectEvent("click", flavor, () => this.select(flavor));
      this.addDirectEvent("keydown", flavor, this.onKeydown.bind(this));
    });
  }

  select(flavor) {
    const index = this.elements.flavors.indexOf(flavor);

    if (index === -1) {
      return;
    }

    this.elements.flavors.forEach((element, position) => {
      const is_active = position === index;

      element.setAttribute("aria-selected", is_active);
      element.setAttribute("tabindex", is_active ? "0" : "-1");
    });

    this.elements.declarations.forEach((declaration, position) => {
      declaration.classList.toggle("state--active", position === index);
    });

    this.closest("product-details-panels")?.measure();
  }

  onKeydown(event) {
    const steps = { ArrowLeft: -1, ArrowRight: 1 };
    const step = steps[event.key];

    if (!step) {
      return;
    }

    event.preventDefault();

    const flavors = this.elements.flavors;
    const current = flavors.indexOf(event.currentTarget);
    const next = (current + step + flavors.length) % flavors.length;

    this.select(flavors[next]);
    flavors[next].focus();
  }
}

customElements.define("product-ingredient-tabs", ProductIngredientTabs);
